import {State} from "./types";
import {RequestStatus} from "interfaces";
import {initialState} from "./initial-state";
import {setRequestStatus} from "../request-status";
import {get, getBanks, updatePaymentStatus} from "./thunks";
import {PayloadAction, createSlice} from "@reduxjs/toolkit";

export const payments = createSlice({
  name: "payments",
  initialState,
  reducers: {
    setPaymentsSliceRequestStatus: function (
      state,
      action: PayloadAction<{
        name: keyof State["request"];
        status: RequestStatus;
      }>,
    ) {
      const {name, status} = action["payload"];
      state["request"][name] = status;
    },
    setPaymentsPagination: function (
      state,
      action: PayloadAction<State["pagination"]>,
    ) {
      state["pagination"] = action["payload"];
    },
    clearPayments: function (state) {
      state["payments"] = [];
    },
  },
  extraReducers: function (builder) {
    builder.addCase(get.fulfilled, function (state, action) {
      const {data, refresh} = action["payload"];
      const {rows, count} = data;
      const nextRows = refresh ? rows : [...state["payments"], ...rows];
      state["payments"] = nextRows;
      state["request"]["payments"] = setRequestStatus("success");
      state["pagination"]["hasMore"] = nextRows["length"] < count;
    });

    builder.addCase(get.rejected, function (state) {
      state["request"]["payments"] = setRequestStatus("error");
    });
    builder.addCase(updatePaymentStatus.fulfilled, function (state, action) {
      let temp = [...state["payments"]];
      const indexOf = temp.findIndex(({id}) => id === action["payload"]["id"]);
      if (indexOf === -1) return;

      temp[indexOf] = action["payload"];
      state["payments"] = temp;
    });

    builder.addCase(getBanks.fulfilled, function (state, action) {
      state["banks"] = action["payload"];
      state["request"]["banks"] = setRequestStatus("success");
    });
    builder.addCase(getBanks.rejected, function (state) {
      state["request"]["banks"] = setRequestStatus("error");
    });
  },
});

export default payments["reducer"];
export const {
  clearPayments,
  setPaymentsPagination,
  setPaymentsSliceRequestStatus,
} = payments["actions"];
